import React from "react";

import classnames from "classnames";

import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("StatusBadge");
type Props = {
  className?: string;
  text: string;
  plural?: string;
  InnerIcon: () => React.ReactNode;
  number?: number;
};

/**
 * @see ![base-status-badge](https://user-images.githubusercontent.com/3603111/181122395-50361a22-f590-4b6d-8343-ccc147964dc8.png)
 */
export const BaseStatusBadge = ({ text, plural, InnerIcon, number, className }: Props) => {
  const classes = classnames(bem(), className);
  const textWithoutNumber = plural && number && number > 1 ? plural : text;
  const textToRender = !number ? text : `${number} ${textWithoutNumber}`;
  return (
    <Div className={classes}>
      <InnerIcon />
      {textToRender}
    </Div>
  );
};

const OkIcon = (): React.ReactNode => <Div className={classnames(bem("tallyDot"))} />;

const WarningIcon = (): React.ReactNode => <Div className={classnames(bem("tallyDotWarning"))} />;

type StatusBadgeProps = {
  number?: number;
};
export const CompleteStatusBadge = ({ number }: StatusBadgeProps) => (
  <BaseStatusBadge text="OK" plural="OK" number={number} InnerIcon={OkIcon} className="Ok" />
);
export const IncompleteStatusBadge = ({ number }: StatusBadgeProps) => (
  <BaseStatusBadge text="Needs Attention" plural="Need Attention" InnerIcon={WarningIcon} number={number} className="Warning" />
);
